import { ScopeData } from "models/ActivityDataEntryScopes/scopes.model";

export const sortItemsById = (items: ScopeData[]): ScopeData[] => {
    if (items.length === 0) return [];
  
    return [...items].sort((a, b) => {
      if (a && b && typeof a.id === 'number' && typeof b.id === 'number') {
        return a.id - b.id;
      }
      return 0; // If id is not present or items are undefined, keep original order
    });
  };
